import { getObjectUtil } from 'packages/src'
import EXERCISES_PATH from '../../constants/path'

const getMusclesFiltersExercisesSelect = state => getObjectUtil(
  state,
  EXERCISES_PATH.MUSCLE_FILTER
)

export default getMusclesFiltersExercisesSelect
